var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.908 15.931 3.018-14.347c.148-.594.074-1.04-.22-1.338-.295-.297-.59-.297-1.031-.148L.932 7.01c-.368.149-.663.297-.81.52-.147.223-.147.372-.074.52.074.15.295.298.663.372l4.565 1.413 10.527-6.69c.295-.224.516-.224.663-.15.074.075.074.15-.074.298l-8.54 7.88-.368 4.758c.295 0 .59-.15.957-.447l2.209-2.155 4.565 3.42c.957.52 1.472.222 1.693-.819z",
    fill: "currentColor"
  })));
};
export default SvgTelegram;